import { HttpRequest, HttpHandlerFn, HttpInterceptorFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, MonoTypeOperatorFunction, Observable, of, pipe, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ErrorService } from '../services';
import { UiError } from '../model';

export const appErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const errorService = inject(ErrorService);
  const catchAppError = (): MonoTypeOperatorFunction<HttpEvent<unknown>> => {
    return pipe(
      catchError(error => {
        return convertPossibleBlobError(error);
      }),
      catchError(error => {
        const e = UiError(error);
        errorService.setError(e);
        return throwError(() => e);
      })
    );
  };

  const convertPossibleBlobError = (err: unknown) => {
    let $error = of(err);
    if (err instanceof HttpErrorResponse && err.error instanceof Blob) {
      $error = convertBlobToHttpError(err);
    }
    return $error.pipe(switchMap(x => throwError(() => x)));
  };

  const convertBlobToHttpError = (err: HttpErrorResponse): Observable<HttpErrorResponse> => {
    return from(err.error.text()).pipe(
      map(
        errorText =>
          new HttpErrorResponse({
            error: JSON.parse(errorText as string),
            headers: err.headers,
            status: err.status,
            statusText: err.statusText,
            url: err.url ?? undefined,
          })
      )
    );
  };

  return next(request).pipe(catchAppError());
};
